import CustomBox from '../CommonComp/CustomBox/CustomBox';
import SoldImages from './SoldImages';
import ImageLink from './ImageLink';
import ImageSearch from './ImageSearch';
import ConfirmedOrder from './ConfirmedOrder';

function LegalTabBody({ activeTab }) {
  return (
    <>
      {activeTab != 2 && (
        <CustomBox
          padding={0}
          sx={{
            minHeight: 200,
            display: 'flex',
            justifyContent: 'center',
            alignItems: activeTab != 2 && 'center',
          }}
        >
          {activeTab == 1 && <SoldImages />}
          {activeTab == 3 && <ImageSearch />}
          {activeTab == 4 && <ConfirmedOrder />}
        </CustomBox>
      )}
      {activeTab == 2 && <ImageLink />}
    </>
  );
}

export default LegalTabBody;
